import { DatadogEventProcessor } from ".";
import { httpResourceTypes, REDACTED_PATH_PARAM, sendgridApiHosts } from "./constants";
import {
  emailRegex,
  numberRegex,
  redactApiKeyRegex,
  redactBillingInvoiceRegex,
  redactDynamicTemplateRegex,
  redactOfferingsRegex,
  redactPaymentRegex,
  redactSubusersRegex,
  redactTeammateRegex,
  redactVerifySenderRegex,
  uuidv4Regex,
} from "./regex";

const redactPathParams = (urlString: string) => {
  const url = new URL(urlString);

  url.pathname = url.pathname
    .replace(numberRegex, REDACTED_PATH_PARAM)
    .replace(emailRegex, REDACTED_PATH_PARAM)
    .replace(uuidv4Regex, REDACTED_PATH_PARAM);

  return url.toString();
};

const redactSpecificAPIPathParams = (urlString: string) => {
  const url = new URL(urlString);

  url.pathname = url.pathname
    .replace(redactApiKeyRegex, REDACTED_PATH_PARAM)
    .replace(redactBillingInvoiceRegex, REDACTED_PATH_PARAM)
    .replace(redactVerifySenderRegex, REDACTED_PATH_PARAM)
    .replace(redactTeammateRegex, REDACTED_PATH_PARAM)
    .replace(redactSubusersRegex, REDACTED_PATH_PARAM)
    .replace(redactOfferingsRegex, REDACTED_PATH_PARAM);

  return url.toString();
};

const redactSpecificViewPathParams = (urlString: string) => {
  const url = new URL(urlString);

  url.pathname = url.pathname
    .replace(redactDynamicTemplateRegex, REDACTED_PATH_PARAM)
    .replace(redactPaymentRegex, `${REDACTED_PATH_PARAM}/${REDACTED_PATH_PARAM}`);

  return url.toString();
};

export const redactUrlPathParams: DatadogEventProcessor = (event) => {
  if (event.type === "resource") {
    const { host } = new URL(event.resource.url);
    const shouldRedactPathParams =
      httpResourceTypes.includes(event.resource.type) && sendgridApiHosts.includes(host);

    if (shouldRedactPathParams) {
      event.resource.url = redactPathParams(event.resource.url);
      event.resource.url = redactSpecificAPIPathParams(event.resource.url);
    }
  }

  if (event.type === "view") {
    event.view.url = redactPathParams(event.view.url);
    event.view.url = redactSpecificViewPathParams(event.view.url);
  }
};
